import React, { useState, useEffect } from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";
import Workservice from "../../service/Workservice";

const Works = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await Workservice.getAllInfo();
      const newData = response.docs.map((doc) => doc.data()); // Extract data from each document
      setData(newData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div className="works">
      <Card
        icon={faBriefcase}
        title="Work"
        body={
          <div className="works-body">
            {data.map((work, index) => (
              <div key={index} className="work">
                <img
                  src={work.image}
                  alt={work.company}
                  className="work-image"
                />
                <div className="work-title">{work.company}</div>
                <div className="work-subtitle">{work.position}</div>
                <div className="work-duration">
                  {work.startYear} - {work.endYear}
                </div>
              </div>
            ))}
          </div>
        }
      />
    </div>
  );
};

export default Works;
